import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import routes from 'app/routes';
import { useContext as useUsersContext } from 'components/Users/Context';
import NoPolicy from './Views/NoPolicy/Index';
import Index from './Views/Index';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  const router = createBrowserRouter([
    {
      path: routes.managers.billing.noPolicy,
      element: <NoPolicy />,
    },
    {
      path: routes.managers.billing.index,
      element: <Index />,
    },
  ]);

  return <RouterProvider router={router} />;
}
